import React from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/images/logo.png";

const SuperAdminLayout = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  const isClinics =
    pathname === "/superadmin" || pathname.startsWith("/superadmin/clinics");
  const isLogs = pathname.startsWith("/superadmin/logs");

  const linkClass = (active: boolean) =>
    [
      "text-sm font-medium px-2 py-1 rounded transition-colors",
      active
        ? "text-white bg-white/15 underline underline-offset-4"
        : "text-white/80 hover:text-white hover:bg-white/10",
    ].join(" ");

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <header className="bg-primary text-white px-6 py-3 flex items-center justify-between shadow">
        <div className="flex items-center gap-4">
          <img src={logo} alt="Dhanvantaree" className="h-10 w-auto" />
          <span className="text-sm font-semibold tracking-wide uppercase opacity-75">
            Super Admin
          </span>
        </div>
        <nav className="flex items-center gap-1 sm:gap-3">
          <Link to="/superadmin" className={linkClass(isClinics)}>
            Clinics
          </Link>
          <Link to="/superadmin/logs" className={linkClass(isLogs)}>
            Logs
          </Link>
          <button
            type="button"
            onClick={handleLogout}
            className="text-sm font-medium px-2 py-1 rounded text-white/80 hover:text-white hover:bg-white/10"
          >
            Logout
          </button>
        </nav>
      </header>
      <main className="flex-1 p-6 max-w-7xl mx-auto w-full">
        <Outlet />
      </main>
    </div>
  );
};

export default SuperAdminLayout;
